import { Col } from '../../components/custom';

export default function DecliningNPS()
{
    return (
        <Col id='decliningNPS' className='perspectives'>
            <Col className='banner'>
                <span className='title'>Diagnosing Root Causes Behind a Declining NPS</span>
                <span className='desc'>Don't just track your score. Understand what's pulling it down.</span>
            </Col>
            <Col className='section'>
                <span className='title'>The Challenge</span>
                <span className='desc bold'>Your Net Promoter Score (NPS) dropped — now what?</span>
                <span className='descsmall'>While NPS is a powerful pulse metric, it's only the starting point. A dip in NPS can signal many different issues: unmet expectations, poor support experiences, product quality concerns, or misaligned communication. Without a deeper analysis, you're left treating symptoms — not causes.</span>
            </Col>
            <Col className='section'>
                <span className='title'>Our Philosophy</span>
                <span className='desc bold'>Look beyond the score. Connect feedback to action.</span>
                <span className='descsmall'>We approach NPS not as a standalone metric, but as part of a broader loyalty and experience framework. The key is connecting promoter/detractor behaviors to real feedback, operational metrics, and moments that matter.</span>
            </Col>
            <Col className='section'>
                <span className='title'>The Diagnostic Framework</span>
                <span className='desc'>A layered approach to uncovering why NPS is falling:</span>
                <ul>
                    <li className='descsmall'>
                        <strong>Score Pattern Decomposition</strong>
                        <ul>
                            <li className='descsmall'>Break down NPS by segment: customer type, geography, lifecycle stage, product line.</li>
                            <li className='descsmall'>Identify which cohorts are becoming detractors — and when.</li>
                        </ul>
                    </li>
                    <li className='descsmall'>
                        <strong>Comment & Sentiment Mining</strong>
                        <ul>
                            <li className='descsmall'>Use NLP to analyze open-text NPS comments.</li>
                            <li className='descsmall'>Detect themes in promoter vs. detractor feedback (e.g., product stability, onboarding experience, pricing transparency).</li>
                        </ul>
                    </li>
                    <li className='descsmall'>
                        <strong>Experience Touchpoint Analysis</strong>
                        <ul>
                            <li className='descsmall'>Map NPS responses against key journey stages and recent interactions.</li>
                            <li className='descsmall'>Identify moments of friction that precede detractor sentiment.</li>
                        </ul>
                    </li>
                    <li className='descsmall'>
                        <strong>Operational Data Integration</strong>
                        <ul>
                            <li className='descsmall'>Combine NPS with support ticket data, product usage patterns, and churn signals.</li>
                            <li className='descsmall'>Validate root causes using behavioral and transactional indicators.</li>
                        </ul>
                    </li>
                </ul>
            </Col>
            <Col className='section'>
                <span className='title'>What This Enables</span>
                <ul>
                    <li className='descsmall'><strong>Root-Cause Clarity</strong> — Know exactly why NPS is falling, not just where.</li>
                    <li className='descsmall'><strong>Tailored CX Improvements</strong> — Act on specific issues (e.g., onboarding delays, pricing confusion) instead of launching generic loyalty campaigns.</li>
                    <li className='descsmall'><strong>Closed-Loop Readiness</strong> — Empower teams to follow up with detractors in a personalized and informed way.</li>
                    <li className='descsmall'><strong>Score Recovery & Growth</strong> — Reverse NPS decline through focused, data-driven interventions.</li>
                </ul>
            </Col>
            <Col className='section'>
                <span className='title'>The Takeaway</span>
                <span className='desc bold'>NPS is not the answer — it's the question.</span>
                <span className='descsmall'>To act meaningfully on NPS, organizations must go deeper into what drives loyalty and dissatisfaction. With the right insight engine, a declining score becomes a roadmap for improvement.</span>
            </Col>
        </Col>
    )
}